import { INBOX_TYPES } from 'dashboard/helper/inbox';

export const assistantsList = [
  {
    account_id: 2,
    config: { product_name: 'HelpDesk Pro' },
    created_at: 1736033561,
    description:
      'An advanced AI assistant designed to enhance customer support solutions by automating workflows and providing instant responses.',
    id: 4,
    name: 'Support Genie',
  },
  {
    account_id: 3,
    config: { product_name: 'CRM Tools' },
    created_at: 1736033562,
    description:
      'Helps streamline customer relationship management by organizing contacts, automating follow-ups, and providing insights.',
    id: 5,
    name: 'CRM Assistant',
  },
  {
    account_id: 4,
    config: { product_name: 'SalesFlow' },
    created_at: 1736033563,
    description:
      'Optimizes your sales pipeline by tracking prospects, forecasting sales, and automating administrative tasks.',
    id: 6,
    name: 'SalesBot',
  },
  {
    account_id: 5,
    config: { product_name: 'TicketMaster AI' },
    created_at: 1736033564,
    description:
      'Automates ticket assignment, categorization, and customer query responses to enhance support efficiency.',
    id: 7,
    name: 'TicketBot',
  },
  {
    account_id: 6,
    config: { product_name: 'FinanceAssist' },
    created_at: 1736033565,
    description:
      'Provides financial analytics, reporting, and insights, helping teams make data-driven financial decisions.',
    id: 8,
    name: 'Finance Wizard',
  },
  {
    account_id: 8,
    config: { product_name: 'HR Assistant' },
    created_at: 1736033567,
    description:
      'Streamlines HR operations including employee management, payroll, and recruitment processes.',
    id: 10,
    name: 'HR Helper',
  },
];

export const documentsList = [
  {
    account_id: 1,
    assistant: { id: 1, name: 'Helper Pro' },
    content:
      'Comprehensive guide on using conversation filters to manage chats effectively.',
    created_at: 1736143272,
    external_link:
      'https://www.chatwoot.com/hc/user-guide/articles/1677688192-how-to-use-conversation-filters',
    id: 3059,
    name: 'How to use Conversation Filters? | User Guide | Chatwoot',
    status: 'available',
  },
  {
    account_id: 2,
    assistant: { id: 2, name: 'Support Genie' },
    content:
      'Step-by-step guide for automating ticket assignments and improving support workflow in Chatwoot.',
    created_at: 1736143273,
    external_link:
      'https://www.chatwoot.com/hc/user-guide/articles/1677688200-automating-ticket-assignments',
    id: 3060,
    name: 'Automating Ticket Assignments | User Guide | Chatwoot',
    status: 'available',
  },
  {
    account_id: 3,
    assistant: { id: 3, name: 'CRM Assistant' },
    content:
      'A detailed guide on managing and organizing customer profiles for better relationship management.',
    created_at: 1736143274,
    external_link:
      'https://www.chatwoot.com/hc/user-guide/articles/1677688210-managing-customer-profiles',
    id: 3061,
    name: 'Managing Customer Profiles | User Guide | Chatwoot',
    status: 'available',
  },
  {
    account_id: 4,
    assistant: { id: 4, name: 'SalesBot' },
    content:
      'Learn how to optimize sales tracking and improve your sales forecasting using advanced features.',
    created_at: 1736143275,
    external_link:
      'https://www.chatwoot.com/hc/user-guide/articles/1677688220-sales-tracking-guide',
    id: 3062,
    name: 'Sales Tracking Guide | User Guide | Chatwoot',
    status: 'available',
  },
  {
    account_id: 5,
    assistant: { id: 5, name: 'TicketBot' },
    content:
      'How to efficiently create, manage, and resolve tickets in Chatwoot.',
    created_at: 1736143276,
    external_link:
      'https://www.chatwoot.com/hc/user-guide/articles/1677688230-managing-tickets',
    id: 3063,
    name: 'Managing Tickets | User Guide | Chatwoot',
    status: 'available',
  },
  {
    account_id: 6,
    assistant: { id: 6, name: 'Finance Wizard' },
    content:
      'Detailed guide on how to use financial reporting tools and generate insightful analytics.',
    created_at: 1736143277,
    external_link:
      'https://www.chatwoot.com/hc/user-guide/articles/1677688240-financial-reporting',
    id: 3064,
    name: 'Financial Reporting | User Guide | Chatwoot',
    status: 'available',
  },
];

export const responsesList = [
  {
    account_id: 1,
    answer:
      'Messenger may be deactivated because you are on a free plan or the limit for inboxes might have been reached.',
    created_at: 1736283330,
    id: 87,
    question: 'Why is my Messenger in Chatwoot deactivated?',
    status: 'pending',
    assistant: {
      account_id: 1,
      config: { product_name: 'Chatwoot' },
      created_at: 1736033280,
      description: 'Assists with general queries and system-wide issues.',
      id: 1,
      name: 'Assistant 2',
    },
  },
  {
    account_id: 2,
    answer:
      'You can integrate your WhatsApp account by navigating to the Integrations section and selecting the WhatsApp integration option.',
    created_at: 1736283340,
    id: 88,
    question: 'How do I integrate WhatsApp with Chatwoot?',
    assistant: {
      account_id: 2,
      config: { product_name: 'Chatwoot' },
      created_at: 1736033281,
      description: 'Helps with integration and setup-related inquiries.',
      id: 2,
      name: 'Assistant 3',
    },
  },
  {
    account_id: 3,
    answer:
      "To reset your password, go to the login page and click on 'Forgot Password', then follow the instructions sent to your email.",
    created_at: 1736283350,
    id: 89,
    question: 'How can I reset my password in Chatwoot?',
    assistant: {
      account_id: 3,
      config: { product_name: 'Chatwoot' },
      created_at: 1736033282,
      description: 'Handles account management and recovery support.',
      id: 3,
      name: 'Assistant 4',
    },
  },
  {
    account_id: 4,
    answer:
      "You can enable the dark mode in settings by navigating to 'Appearance' and selecting 'Dark Mode'.",
    created_at: 1736283360,
    id: 90,
    question: 'How do I enable dark mode in Chatwoot?',
    assistant: {
      account_id: 4,
      config: { product_name: 'Chatwoot' },
      created_at: 1736033283,
      description: 'Helps with UI and theme-related inquiries.',
      id: 4,
      name: 'Assistant 5',
    },
  },
  {
    account_id: 5,
    answer:
      "To add a new team member, navigate to 'Settings', then 'Team', and click on 'Add Team Member'.",
    created_at: 1736283370,
    id: 91,
    question: 'How do I add a new team member in Chatwoot?',
    assistant: {
      account_id: 5,
      config: { product_name: 'Chatwoot' },
      created_at: 1736033284,
      description: 'Supports team management and user access-related queries.',
      id: 5,
      name: 'Assistant 6',
    },
  },
  {
    account_id: 6,
    answer:
      "Campaigns in Chatwoot allow you to send targeted messages to specific user segments. You can create them in the 'Campaigns' section.",
    created_at: 1736283380,
    id: 92,
    question: 'What are campaigns in Chatwoot?',
    assistant: {
      account_id: 6,
      config: { product_name: 'Chatwoot' },
      created_at: 1736033285,
      description:
        'Specialized in marketing, campaign management, and messaging strategies.',
      id: 6,
      name: 'Assistant 7',
    },
  },
];

export const scenariosExample = [
  {
    id: 1,
    title: 'Prospective Buyer',
    description:
      'Handle customers who are showing interest in purchasing a license',
    instruction:
      'If someone is interested in purchasing a license, ask them for following:\n\n1. How many licenses are they willing to purchase?\n2. Are they migrating from another platform?\n. Once these details are collected, do the following steps\n1. add a private note to with the information you collected using [Add Private Note](tool://add_private_note)\n2. Add label "sales" to the contact using [Add Label to Conversation](tool://add_label_to_conversation)\n3. Reply saying "one of us will reach out soon" and provide an estimated timeline for the response and [Handoff to Human](tool://handoff)',
    tools: ['add_private_note', 'add_label_to_conversation', 'handoff'],
  },
];

export const inboxes = [
  {
    id: 7,
    name: 'Email Support',
    channel_type: INBOX_TYPES.EMAIL,
    email: 'support@company.com',
  },
  {
    id: 1,
    name: 'Website Chat',
    channel_type: INBOX_TYPES.WEB,
  },
  {
    id: 2,
    name: 'Facebook Support',
    channel_type: INBOX_TYPES.FB,
  },
  {
    id: 5,
    name: 'SMS Service',
    channel_type: INBOX_TYPES.TWILIO,
    messaging_service_sid: 'MGxxxxxx',
  },
  {
    id: 6,
    name: 'WhatsApp Support',
    channel_type: INBOX_TYPES.WHATSAPP,
    phone_number: '+1987654321',
  },
  {
    id: 8,
    name: 'Telegram Support',
    channel_type: INBOX_TYPES.TELEGRAM,
  },
  {
    id: 9,
    name: 'LINE Support',
    channel_type: INBOX_TYPES.LINE,
  },
  {
    id: 10,
    name: 'API Channel',
    channel_type: INBOX_TYPES.API,
  },
  {
    id: 11,
    name: 'SMS Basic',
    channel_type: INBOX_TYPES.SMS,
    phone_number: '+1555555555',
  },
];

const zhCNAssistantsList = [
  {
    account_id: 2,
    config: { product_name: 'HelpDesk Pro' },
    created_at: 1736033561,
    description:
      '高级 AI 助手，可自动化工作流并提供即时回复，提升客户支持效率。',
    id: 4,
    name: '支持精灵',
  },
  {
    account_id: 3,
    config: { product_name: 'CRM Tools' },
    created_at: 1736033562,
    description:
      '帮助整理联系人、自动跟进并提供洞察，简化客户关系管理。',
    id: 5,
    name: 'CRM 助手',
  },
  {
    account_id: 4,
    config: { product_name: 'SalesFlow' },
    created_at: 1736033563,
    description:
      '跟踪潜在客户、预测销售并自动化行政任务，优化销售流程。',
    id: 6,
    name: '销售机器人',
  },
  {
    account_id: 5,
    config: { product_name: 'TicketMaster AI' },
    created_at: 1736033564,
    description:
      '自动化工单分配、分类与客户问询回复，提升支持团队效率。',
    id: 7,
    name: '工单机器人',
  },
  {
    account_id: 6,
    config: { product_name: 'FinanceAssist' },
    created_at: 1736033565,
    description:
      '提供财务分析、报表与洞察，帮助团队做出数据驱动的财务决策。',
    id: 8,
    name: '财务助手',
  },
  {
    account_id: 8,
    config: { product_name: 'HR Assistant' },
    created_at: 1736033567,
    description: '简化员工管理、薪资与招聘等人力资源流程。',
    id: 10,
    name: '人事助手',
  },
];

const zhCNDocumentsList = [
  {
    account_id: 1,
    assistant: { id: 1, name: '客服助手' },
    content: '全面介绍如何使用会话筛选功能高效管理对话。',
    created_at: 1736143272,
    external_link:
      'https://www.chatwoot.com/hc/user-guide/articles/1677688192-how-to-use-conversation-filters',
    id: 3059,
    name: '如何使用会话筛选？ | 用户指南 | Chatwoot',
    status: 'available',
  },
  {
    account_id: 2,
    assistant: { id: 2, name: '支持精灵' },
    content: '分步说明如何自动化工单分配并优化 Chatwoot 支持流程。',
    created_at: 1736143273,
    external_link:
      'https://www.chatwoot.com/hc/user-guide/articles/1677688200-automating-ticket-assignments',
    id: 3060,
    name: '自动化工单分配 | 用户指南 | Chatwoot',
    status: 'available',
  },
  {
    account_id: 3,
    assistant: { id: 3, name: 'CRM 助手' },
    content: '详细介绍如何管理与客户资料，改善客户关系维护。',
    created_at: 1736143274,
    external_link:
      'https://www.chatwoot.com/hc/user-guide/articles/1677688210-managing-customer-profiles',
    id: 3061,
    name: '管理客户资料 | 用户指南 | Chatwoot',
    status: 'available',
  },
  {
    account_id: 4,
    assistant: { id: 4, name: '销售机器人' },
    content: '了解如何优化销售跟踪，并利用高级功能改进销售预测。',
    created_at: 1736143275,
    external_link:
      'https://www.chatwoot.com/hc/user-guide/articles/1677688220-sales-tracking-guide',
    id: 3062,
    name: '销售跟踪指南 | 用户指南 | Chatwoot',
    status: 'available',
  },
  {
    account_id: 5,
    assistant: { id: 5, name: '工单机器人' },
    content: '如何高效创建、管理与解决 Chatwoot 中的工单。',
    created_at: 1736143276,
    external_link:
      'https://www.chatwoot.com/hc/user-guide/articles/1677688230-managing-tickets',
    id: 3063,
    name: '管理工单 | 用户指南 | Chatwoot',
    status: 'available',
  },
  {
    account_id: 6,
    assistant: { id: 6, name: '财务助手' },
    content: '详细介绍如何使用财务报表工具并生成有价值的分析。',
    created_at: 1736143277,
    external_link:
      'https://www.chatwoot.com/hc/user-guide/articles/1677688240-financial-reporting',
    id: 3064,
    name: '财务报表 | 用户指南 | Chatwoot',
    status: 'available',
  },
];

const zhCNResponsesList = [
  {
    account_id: 1,
    answer:
      'Messenger 可能被停用，原因可能是您使用的是免费套餐，或收件箱数量已达上限。',
    created_at: 1736283330,
    id: 87,
    question: '为什么 Chatwoot 中的 Messenger 被停用了？',
    status: 'pending',
    assistant: {
      account_id: 1,
      config: { product_name: 'Chatwoot' },
      created_at: 1736033280,
      description: '协助处理一般咨询与系统相关问题。',
      id: 1,
      name: '助手 2',
    },
  },
  {
    account_id: 2,
    answer:
      '您可以在「集成」页面选择 WhatsApp 集成，按步骤完成 WhatsApp 账号连接。',
    created_at: 1736283340,
    id: 88,
    question: '如何将 WhatsApp 与 Chatwoot 集成？',
    assistant: {
      account_id: 2,
      config: { product_name: 'Chatwoot' },
      created_at: 1736033281,
      description: '帮助处理集成与配置相关咨询。',
      id: 2,
      name: '助手 3',
    },
  },
  {
    account_id: 3,
    answer:
      '要重置密码，请前往登录页点击「忘记密码」，然后按邮件中的说明操作。',
    created_at: 1736283350,
    id: 89,
    question: '如何在 Chatwoot 中重置密码？',
    assistant: {
      account_id: 3,
      config: { product_name: 'Chatwoot' },
      created_at: 1736033282,
      description: '处理账户管理与找回相关支持。',
      id: 3,
      name: '助手 4',
    },
  },
  {
    account_id: 4,
    answer:
      '您可以在「设置」→「外观」中选择「深色模式」来启用深色主题。',
    created_at: 1736283360,
    id: 90,
    question: '如何在 Chatwoot 中启用深色模式？',
    assistant: {
      account_id: 4,
      config: { product_name: 'Chatwoot' },
      created_at: 1736033283,
      description: '帮助处理界面与主题相关咨询。',
      id: 4,
      name: '助手 5',
    },
  },
  {
    account_id: 5,
    answer:
      '要添加新团队成员，请前往「设置」→「团队」，然后点击「添加团队成员」。',
    created_at: 1736283370,
    id: 91,
    question: '如何在 Chatwoot 中添加新团队成员？',
    assistant: {
      account_id: 5,
      config: { product_name: 'Chatwoot' },
      created_at: 1736033284,
      description: '支持团队管理与成员权限相关咨询。',
      id: 5,
      name: '助手 6',
    },
  },
  {
    account_id: 6,
    answer:
      'Chatwoot 中的营销活动可向特定用户群体发送定向消息，可在「营销活动」页面创建。',
    created_at: 1736283380,
    id: 92,
    question: 'Chatwoot 中的营销活动是什么？',
    assistant: {
      account_id: 6,
      config: { product_name: 'Chatwoot' },
      created_at: 1736033285,
      description: '专注于营销、活动管理与消息策略。',
      id: 6,
      name: '助手 7',
    },
  },
];

const zhCNInboxes = [
  {
    id: 7,
    name: '邮件支持',
    channel_type: INBOX_TYPES.EMAIL,
    email: 'support@company.com',
  },
  {
    id: 1,
    name: '网站聊天',
    channel_type: INBOX_TYPES.WEB,
  },
  {
    id: 2,
    name: 'Facebook 支持',
    channel_type: INBOX_TYPES.FB,
  },
  {
    id: 5,
    name: '短信服务',
    channel_type: INBOX_TYPES.TWILIO,
    messaging_service_sid: 'MGxxxxxx',
  },
  {
    id: 6,
    name: 'WhatsApp 支持',
    channel_type: INBOX_TYPES.WHATSAPP,
    phone_number: '+1987654321',
  },
  {
    id: 8,
    name: 'Telegram 支持',
    channel_type: INBOX_TYPES.TELEGRAM,
  },
  {
    id: 9,
    name: 'LINE 支持',
    channel_type: INBOX_TYPES.LINE,
  },
  {
    id: 10,
    name: 'API 渠道',
    channel_type: INBOX_TYPES.API,
  },
  {
    id: 11,
    name: '短信基础版',
    channel_type: INBOX_TYPES.SMS,
    phone_number: '+1555555555',
  },
];

const zhCNScenariosExample = [
  {
    id: 1,
    title: '潜在买家',
    description: '处理对购买许可证感兴趣的客户',
    instruction:
      '如果有人对购买许可证感兴趣，请询问以下信息：\n\n1. 他们打算购买多少份许可证？\n2. 他们是否从其他平台迁移过来？\n\n收集完这些信息后，执行以下步骤：\n1. 使用 [添加私人备注](tool://add_private_note) 将收集到的信息添加为私人备注\n2. 使用 [为会话添加标签](tool://add_label_to_conversation) 为联系人添加 "sales" 标签\n3. 回复「我们会尽快与您联系」，并提供预计回复时间，然后 [转交人工客服](tool://handoff)',
    tools: ['add_private_note', 'add_label_to_conversation', 'handoff'],
  },
];

const EMPTY_STATE_CONTENT = {
  en: {
    assistantsList,
    documentsList,
    responsesList,
    inboxes,
    scenariosExample,
  },
  zh_CN: {
    assistantsList: zhCNAssistantsList,
    documentsList: zhCNDocumentsList,
    responsesList: zhCNResponsesList,
    inboxes: zhCNInboxes,
    scenariosExample: zhCNScenariosExample,
  },
};

export function getEmptyStateContent(key, locale) {
  const normalizedLocale = locale?.startsWith('zh') ? 'zh_CN' : 'en';
  return EMPTY_STATE_CONTENT[normalizedLocale][key];
}
